import { STRING } from "../constants/string";
import { MedLocales, MedLocalizationFilePath } from "../types";

export class ApiUrlAdapter {
  constructor(apiUrl: string, locale: keyof MedLocales, projectName: string, { folder, file }: MedLocalizationFilePath) {
    const url = [apiUrl, locale, projectName, folder, file].join(STRING.SLASH);
    this.url = `${url}${STRING.FILE.JSON}`;
  }

  url: string = STRING.EMPTY;
}
